import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { InsuredPersonRiskDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getInsuredRiskCaption } from "web_myplann/Portfolio/Helpers/insuredPersonLabels";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

const MISSING_RISK_VALUE = "—";

type Props = {
	risk: InsuredPersonRiskDTO;
	currencySign: string;
};

export const InsuredRiskDetailRow: FC<Props> = ({ risk, currencySign }) => {
	const { t } = useResource();
	const theme = useTheme();

	const caption = getInsuredRiskCaption(risk, t);

	return (
		<Stack
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			sx={{
				borderBottom: theme.colors.border.solid(theme.palette.divider),
				"&:last-of-type": { borderBottom: "none" },
			}}
		>
			<Stack
				direction="row"
				alignItems="baseline"
				justifyContent="space-between"
				gap={theme.spacingTokens.xl}
			>
				<Typography variant="body2">
					{t(Resources.PortfolioDetail.LifeInsurance.Risk[risk.risk])}
				</Typography>
				<Typography variant="bodyStrong" tabular textAlign="right">
					{moneyFormatter(risk.value, currencySign, MISSING_RISK_VALUE)}
				</Typography>
			</Stack>
			{caption && (
				<Typography variant="caption" color="text.secondary">
					{caption}
				</Typography>
			)}
		</Stack>
	);
};
